export const queryKeys = {
  userLeagues:        () => ['userLeagues'] as const,
  userProfile:        () => ['userProfile'] as const,
  userLeaguePredictions: (leagueId: string) => ['userLeaguePredictions', leagueId] as const,
  leagueDetails:      (id: string) => ['leagueDetails', id] as const,
  leagueStandings:    (id: string) => ['leagueStandings', id] as const,
  leagueMembers:      (id: string) => ['leagueMembers', id] as const,
  leagueMessages:     (id: string) => ['leagueMessages', id] as const,
  leagueEventPrediction:  (lid: string, eid: string) => ['leagueEventPrediction', lid, eid] as const,
  leagueEventResults:      (lid: string, eid: string) => ['leagueEventResults', lid, eid] as const,
  leagueEventPredictions:  (lid: string, eid: string) => ['leagueEventPredictions', lid, eid] as const,
  leagueEventPredictionStatus: (lid: string, eid: string) => ['leagueEventPredictionStatus', lid, eid] as const,
  leagueTypes:        () => ['leagueTypes'] as const,
  leagueTypeEvents:   (id: string) => ['leagueTypeEvents', id] as const,
  events:             (tid: string, status: string) => ['events', tid, status] as const,
  event:              (id: string) => ['event', id] as const,
  liveRaceEvent:      (tid: string) => ['liveRaceEvent', tid] as const,
  f1Drivers:          (tid: string) => ['f1Drivers', tid] as const,
  inviteToken:        (tok: string) => ['inviteToken', tok] as const,
} as const;
